import React from 'react'
import { PreviewBody, PreviewFooter, PreviewLabel, PreviewLayout } from '../sub-components/PreviewLayout'
import { PaymentsPageType } from 'src/lib/types/uiPreview'
import LoadingList from '../skeletons/LoadingList'
import LoadingDiscountStrip from '../skeletons/LoadingDiscountStrip'
import PreviewBanner from '../sub-components/PreviewBanner'
import LoadingPaymentMethod from '../skeletons/LoadingPaymentMethod'

const PaymentsPage: React.FC<PaymentsPageType> = ({ paymentBanner, paymentsCouponVisibility }) => {
  return (
    <PreviewLayout>
      <>
        <PreviewLabel>
          {paymentBanner.enabled ? (
            <PreviewBanner
              backgroundColor={paymentBanner.color ?? '#5a31f4'}
              textColor={paymentBanner.textColor ?? '#FFFFFF'}
              bannerText={paymentBanner.text ?? '(Enter some text to see a preview here)'}
            />
          ) : (
            <></>
          )}
        </PreviewLabel>
        <PreviewBody>
          <LoadingList
            length={2}
            skeleton={{
              layout: 'row',
              config: [
                { height: 1, width: 1 },
                { height: 1, width: 6 }
              ]
            }}
          />
          <LoadingDiscountStrip
            isHidden={!Boolean(paymentsCouponVisibility?.areCouponsVisible)}
            skeleton={{
              layout: 'row',
              justify: 'space-between',
              config: [
                {
                  layout: 'row',
                  config: [
                    { height: 1, width: 1 },
                    { height: 1, width: 6 }
                  ]
                },
                { height: 1, width: 1 }
              ]
            }}
            isCard={paymentsCouponVisibility?.visibilityExtent === 'cards'}
          />
          <LoadingPaymentMethod
            length={2}
            skeleton={{
              layout: 'row',
              config: [
                { height: 2.5, width: 2.5 },
                { height: 1, width: 6 }
              ]
            }}
          />
        </PreviewBody>
      </>
    </PreviewLayout>
  )
}

export default PaymentsPage
